module.exports = __webpack_public_path__ + "img/fathom-analytics.81f7694a.svg";